export default function PrivacyPage() {
  return (
    <div className="prose w-full max-w-4xl py-10">
      <h1>Privacy Policy</h1>
      <p>Last updated: November 20, 2025</p>

      <p>
        Keypath Labs ("we," "us," or "our") operates Quizzler globally. This policy explains what data we collect,
        how we use it, and the choices you have. By using the site, you agree to these practices.
      </p>

      <h2>What we collect</h2>
      <ul>
        <li>
          <strong>Usage and device logs</strong>: standard web server logs, which can include IP address, browser type,
          timestamps, and pages requested.
        </li>
        <li>
          <strong>Advertising data</strong>: Google Ads may set cookies or similar identifiers to measure ad delivery
          and performance.
        </li>
        <li>
          <strong>Support communications</strong>: emails you send to <a href="mailto:support@keypathlabs.com">support@keypathlabs.com</a>.
        </li>
        <li>
          <strong>Future features</strong>: if we add new functionality, we may collect only what is necessary to run it
          and will update this policy.
        </li>
      </ul>

      <h2>How we use data</h2>
      <ul>
        <li>Operate, maintain, and improve the site.</li>
        <li>Serve and measure advertising.</li>
        <li>Detect, prevent, and address technical issues.</li>
        <li>Respond to support requests.</li>
      </ul>

      <h2>Sharing</h2>
      <p>
        We share data with service providers that help us operate the site (for example, advertising networks). We do not
        sell personal data.
      </p>

      <h2>Cookies and similar technologies</h2>
      <p>
        Google Ads may use cookies or similar identifiers. You can manage cookies through your browser settings. Using
        the site indicates consent to this use.
      </p>

      <h2>Retention</h2>
      <p>
        We keep logs and related data indefinitely. You can request deletion or clearing where feasible by emailing
        <a href="mailto:support@keypathlabs.com">support@keypathlabs.com</a>.
      </p>

      <h2>Security</h2>
      <p>
        We use standard web security practices, including HTTPS. No system is fully secure, so use the service at
        your own risk.
      </p>

      <h2>International use</h2>
      <p>
        The service is offered worldwide. Your data may be processed in any country where we or our service providers
        operate.
      </p>

      <h2>Children</h2>
      <p>
        The site is not directed to children. If you believe a child has provided data, contact us for removal.
      </p>

      <h2>Your choices</h2>
      <ul>
        <li>Disable cookies in your browser to limit ad tracking.</li>
        <li>Email <a href="mailto:support@keypathlabs.com">support@keypathlabs.com</a> to request data deletion where feasible.</li>
      </ul>

      <h2>Changes</h2>
      <p>
        We may update this policy. Continued use after an update means you accept the revised version. We will revise the
        "Last updated" date when changes are made.
      </p>

      <h2>Contact</h2>
      <p>
        Email privacy questions to <a href="mailto:support@keypathlabs.com">support@keypathlabs.com</a>.
      </p>
    </div>
  );
}
